import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/tetractys.pdf'; 
import { Helmet } from 'react-helmet';

function Tetractys() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series VI volume 4</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        pp 1162-1163<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: first half of 1683 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (173k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Remarks on Erhard Weigel’s Tetractys</title>
            <meta name="description" content="An English translation of REMARKS ON ERHARD WEIGEL'S 'TETRACTYS' by Gottfried Wilhelm Leibniz, from first half of 1683 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: REMARKS ON ERHARD WEIGEL'S <var>TETRACTYS</var></h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A VI 4, 1162</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Erhard Weigel, <var>Tetractys</var>, Jena, at Meyer's expense, 1673, 4<sup>o</sup>.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;From the tetractys there sometimes arises lengthier strings of numbers, but on the other hand the [individual] digits are so much easier to work with, since the mind easily grasps two and three, whereas even the attentive mind does not distinctly penetrate seven, eight and nine except through several concepts. Common folk freely use [the quaternary], for they make one digit from four barleycorns,<a name="1" href="#note1"><sup>1</sup></a> one palm from four digits, one foot from four palms, one pace from four feet, and one perch from four paces. Accordingly, they divide the forearm into 4 quarters and therefore into 16 parts. They divide day and night into four parts, the hour into four quarters, musical time into 4 commas, pauses by quaternal lines; and in these ways they bring back these spans of time to a measure. They divide intensive qualities into 4 degrees, weights into four [<b>A VI 4, 1163</b>] moments. They count pears, apples, nuts, eggs, nails, and other such things in 15s — 15 being a mandel with a unit added separately for the quantity of the hinge, that is, by 16, and count out 60, that is a schock, with 4 units to their buyers’ by indicators of fifteens. Before one’s eyes they depict tankards for drinkers in a tavern, pecks of grain for day labourers and transporters etc. through four slashes in a row called a Fahne. In expressing all numbers, [they use] four cardinal articles: one, ten, one hundred, one thousand. Likewise, the Dalecarlians counted by fours in copper coins by heaps of four coins, and our country folk everywhere attest to this. There is no reason [to count] with ten fingers, for when one thumb is viewed separately, there are four [fingers] on each hand. The Thracians perhaps counted in this way, according to the Pythagorean author Zamolxis, and for that reason cowards considered them to be a laughing-stock. The abacus (instead of the commonly called Pythagorean [table]) is made of two lines: twice three are four and two, three threes are eight and one. In subtraction it provides for only two distances, rarely for a third. In division, this is neither added nor subtracted, and out of the three usual words, <var>in</var>, <var>times</var>, <var>from</var>, there remains only <var>in</var>. (+ I think that the binary is best absolutely, the ternary in planes, the octonary in solids. +) Decimal is more sensual, when counting with the fingers; but it does not follow the character of the mind, only the fingers.<br />
                <var>Ein&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vier&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Secht&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Schock</var><br />
                &nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;64
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> That is, from the breadth of four barleycorns.
                <br /><br /><br />
                &#169; Lloyd Strickland 2022<br />
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Tetractys;
